import React from "react";
import PageLayout from "../UI/PageLayout";
import { GenericReportingDropdowns } from "../../containers/GenericReportingDropdowns";
import CreationPage from "../../containers/CampaignMappings/CreationPage";
import RegexPage from "../../containers/CampaignMappings/RegexPage";
import { Tabs } from "antd";

const CampaignMappingsSettingsPage = () => {
  return (
    <PageLayout
      title="Campaign Mappings"
      subTitle="Configure campaign mapping rules and settings"
      dropdowns={
        <GenericReportingDropdowns
          includeDateRange={true}
          includeRegion={false}
          includeSingleSelectRegion={true}
          includeGranularity={false}
          includeTooltipsAndTitles={false}
          includeCompareDateRange={false}
        />
      }
      content={
        <div style={{width: '100%'}}>
          <Tabs>
            <Tabs.TabPane tab="Creation" key="creation">
              <CreationPage />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Regex" key="regex">
              <RegexPage />
            </Tabs.TabPane>
          </Tabs>
        </div>
      }
    />
  );
};

export default CampaignMappingsSettingsPage;


